export default "__VITE_ASSET__DlXHxK0m__"